// One-shot things that happened during a sim step. Render and audio drain
// these each frame; they never feed back into the sim.

export type SimEvent =
  | { type: 'lightning'; x: number; z: number; distance: number; intensity: number }
  | { type: 'cannonFire'; index: number; x: number; y: number; z: number; dx: number; dy: number; dz: number; vessel: number; weight: number }
  | { type: 'splash'; x: number; y: number; z: number; size: number; kind: 'ball' | 'slam' | 'object' | 'wreck' }
  | { type: 'slam'; x: number; y: number; z: number; intensity: number; side: number }
  | { type: 'washOver'; x: number; y: number; z: number; intensity: number; side: number; localX: number }
  | { type: 'creak'; intensity: number; x: number; y: number; z: number; pitch: number }
  | { type: 'sailFill'; sail: string; intensity: number; x: number; y: number; z: number }
  | { type: 'objectHit'; intensity: number; x: number; y: number; z: number }
  | { type: 'bell'; strikes: number }
  /** Shot striking a ship: what it hit and how hard (1 = 12-pdr at the muzzle). */
  | { type: 'impact'; x: number; y: number; z: number; what: 'hull' | 'rail' | 'deck' | 'mast' | 'sail' | 'rigging' | 'gun' | 'rudder' | 'crew' | 'boat'; energy: number; vessel: number; nx: number; ny: number; nz: number }
  | { type: 'explosion'; x: number; y: number; z: number; size: number; vessel: number }
  | { type: 'collapse'; x: number; y: number; z: number; what: string; size: number }
  | { type: 'mastFall'; x: number; y: number; z: number; mast: string; level: number; side: number }
  | { type: 'fire'; x: number; y: number; z: number; vessel: number; started: boolean }
  | { type: 'casualty'; x: number; y: number; z: number; vessel: number; killed: boolean }
  | { type: 'shipSinking'; vessel: number; x: number; z: number }
  | { type: 'shipSunk'; vessel: number; x: number; z: number; cls: string }
  | { type: 'struck'; vessel: number }
  | { type: 'boarding'; a: number; b: number; x: number; z: number }
  | { type: 'captured'; vessel: number; by: number }
  | { type: 'collision'; x: number; y: number; z: number; energy: number }
  | { type: 'sighted'; vessel: number; target: number }
  | { type: 'signal'; vessel: number; x: number; y: number; z: number };

export class SimEvents {
  private list: SimEvent[] = [];

  push(e: SimEvent): void {
    if (this.list.length < 512) this.list.push(e);
  }

  /** Events queued since a mark (without draining). */
  since(mark: number): SimEvent[] {
    return this.list.slice(mark);
  }

  get mark(): number {
    return this.list.length;
  }

  /** Return and clear everything queued since the last drain. */
  drain(): SimEvent[] {
    const out = this.list;
    this.list = [];
    return out;
  }
}
